import { NestedHome } from '@habity/types';
import { HomeDataBuilder } from './data-builder';
import { createEconomyBuildingsFields } from './economyBuildings-fields';

export const getEconomyBuildingsData = (home: NestedHome) => {
  if (!home.provider_data || !home.provider_type) return [];

  const dynamicFields = createEconomyBuildingsFields({ home });
  
  return new HomeDataBuilder(home)
    .addFields(dynamicFields)
    .build();
};

export const getEconomyBuildingsDescription = (home: NestedHome) => {
  const { property_designation } = home?.address || {};
  return property_designation
    ? `Ekonomibyggnader för ${property_designation}`
    : 'Ekonomibyggnader';
};
